import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "need-help__title__icon title-3 text-primary-blue d-flex gap-1" }
const _hoisted_2 = { class: "need-help__title" }
const _hoisted_3 = { class: "need-help__description mt-2" }
const _hoisted_4 = { class: "need-help__link d-flex justify-content-end position-relative" }
const _hoisted_5 = ["href", "target", "rel"]

import { computed } from 'vue'

  // Types
  import { Locale } from '@/types'

  // Components
  import ChevronRight from '@/assets/ChevronRight.vue'

  // Config
  import { links, Links } from '@/config/links'

  // Store
  import { useStore } from '@/store'
  import YoonlyService from '@/services/YoonlyService'

  // Composables
  import useScreenSize from '@/composables/useScreenSize'

  //   Translations
  import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'NeedHelpSection',
  setup(__props) {

  const store = useStore()

  // Services
  const { t } = useI18n()

  const isYoonly = new YoonlyService().isYoonly
  const { isMobile } = useScreenSize()

  // Computed
  const link = computed<string>(() => {
    const locale = store.getters.getLocale as Locale
    const linkKey = isYoonly
      ? 'yoonly'
      : locale === 'en-US'
        ? 'en-GB'
        : (locale as Exclude<Locale, 'en-US'>)

    const localeLinks: Links = links[linkKey]
    if (!localeLinks) throw new Error('invalid locale in getLink')
    return localeLinks.contact || ''
  })

  // mailto:/tel: with target=_blank opens an empty tab; https stays in a new tab.
  const contactLinkTarget = computed(() => {
    const l = link.value
    if (l.startsWith('mailto:') || l.startsWith('tel:')) return undefined
    return '_blank'
  })

  const contactLinkRel = computed(() =>
    contactLinkTarget.value === '_blank' ? 'noopener noreferrer' : undefined
  )


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["bg-blue-100 p-4", { 'need-help--clear-sticky': _unref(isMobile) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createStaticVNode("<span class=\"need-help__icon\" data-v-199c550a><svg width=\"30\" height=\"31\" viewBox=\"0 0 30 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-199c550a><path d=\"M2.17493 10.7929V21.7703C2.17493 23.1281 3.27614 24.2293 4.63386 24.2293H6.08607V28.5666L10.9885 24.2293H17.3451C18.7028 24.2293 19.804 23.1281 19.804 21.7703V10.7929C19.804 9.4352 18.7028 8.33398 17.3451 8.33398H4.63386C3.27614 8.33398 2.17493 9.4352 2.17493 10.7929V10.7929Z\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-linejoin=\"round\" data-v-199c550a></path><path d=\"M25.366 2.96094H12.6548C11.2971 2.96094 10.1959 4.06215 10.1959 5.41987V8.33394H17.3451C18.7028 8.33394 19.804 9.43515 19.804 10.7929V19.5582L23.9138 23.1936V18.8562H25.366C26.7237 18.8562 27.8249 17.755 27.8249 16.3973V5.41987C27.8249 4.06215 26.7237 2.96094 25.366 2.96094Z\" fill=\"var(--primary-blue)\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" data-v-199c550a></path><path d=\"M6.08606 13.0664H15.8928\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" data-v-199c550a></path><path d=\"M6.08606 16.2793H15.8928\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" data-v-199c550a></path><path d=\"M6.08606 19.4941H15.8928\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" data-v-199c550a></path></svg></span>", 1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('needHelp.title')), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('needHelp.description')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: link.value,
        target: contactLinkTarget.value,
        rel: contactLinkRel.value,
        class: "link-small d-flex align-items-center cursor-pointer"
      }, [
        _createTextVNode(_toDisplayString(_unref(t)('needHelp.contact')) + " ", 1),
        _createVNode(ChevronRight)
      ], 8, _hoisted_5)
    ])
  ], 2))
}
}

})